import { BaseDisplayer } from './BaseDisplayer';
import { ValueType } from '../FormatterTypes';
import { insertIntoString } from '../Utils/Other';

class TEDDisplayTelNr extends BaseDisplayer {
  public static getInstance() {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayTelNr;

  defaultParams(): string {
    return '';
  }

  display(
    value: ValueType,
    displayText?: boolean,
    params: string = ''
  ): string {
    const insertSpace = (str: string): string => {
      switch (str.length) {
        case 5: // 999 99
          return insertIntoString(' ', str, 3);
        case 6: // 99 99 99
          return str.slice(0, 2) + ' ' + str.slice(2, 4) + ' ' + str.slice(4);
        case 7: // 999 99 99
          return str.slice(0, 3) + ' ' + str.slice(3, 5) + ' ' + str.slice(5);
        case 8: // 999 999 99
          return str.slice(0, 3) + ' ' + str.slice(3, 6) + ' ' + str.slice(6);
        default:
          return str;
      }
    };
    const valAsStr = String(value ?? '');

    if (displayText && valAsStr !== '') {
      let regexForeign = /^\+(\d{2})(\d{1,3})-(\d{5,12})$/;
      let regexRegDash = /^(\d{2,4})-(\d{5,8})$/;
      let regexOther = /^(\d{5,8})$/;

      let regForeignResult = regexForeign.exec(valAsStr);
      let regDashResult = regexRegDash.exec(valAsStr);
      let regOtherResult = regexOther.exec(valAsStr);
      if (
        regForeignResult &&
        regForeignResult[1] !== '' &&
        regForeignResult[2] !== '' &&
        regForeignResult[3] !== ''
      ) {
        return (
          '+' +
          regForeignResult[1] +
          '(0)' +
          regForeignResult[2] +
          '-' +
          insertSpace(regForeignResult[3])
        );
      } else if (
        regDashResult &&
        regDashResult[0] !== '' &&
        regDashResult[1] !== ''
      ) {
        return regDashResult[1] + '-' + insertSpace(regDashResult[2]);
      } else if (regOtherResult) {
        return insertSpace(valAsStr);
      }
    }

    return valAsStr;
  }
}

export { TEDDisplayTelNr };
